<template>
  <div class="container-fluid">
    <div class="row">
      <div
        class="col-lg-2 col-md-2"
        style="padding-left: 0px; padding-right: 0px"
      >
        <Sidebar />
      </div>
      <div class="col-lg-10 col-md-10 col-12 mt-2">
        <div class="row d-flex justify-content-end cnt" v-if="devices.length">
          <div class="col-sm-1" style="color: #44d7b6">
            Online:<span class="num">{{ onlineCount }}</span>
          </div>
          <div class="col-sm-1" style="color: #ff8080">
            Offline:<span class="num">{{ offlineCount }}</span>
          </div>
          <div class="col-sm-1" style="color: #4d4dff">
            Total:<span class="num">{{ totalRecCount }}</span>
          </div>
        </div>
        <ul class="nav nav-tabs" id="myTab" role="tablist">
          <li class="nav-item" @click="[emptyDevices(),setRoute('cust')]">
            <a
              class="nav-link"
              :class="[currentPage ? currentPage.includes('cust') ? activeNav: '' : '']"
              id="home-tab"
              data-toggle="tab"
              href="#home"
              role="tab"
              aria-controls="home"
              aria-selected="true"
              >Customer</a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              :class="[currentPage ? currentPage.includes('loc') ? activeNav: '' : '']"
              id="profile-tab"
              data-toggle="tab"
              href="#profile"
              role="tab"
              aria-controls="profile"
              aria-selected="false"
              @click="[emptyDevices(), setRoute('loc')]"
              >Location</a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              :class="[currentPage ? currentPage.includes('all') ? activeNav: '' : '']"
              id="contact-tab"
              data-toggle="tab"
              href="#contact"
              role="tab"
              aria-controls="contact"
              aria-selected="false"
              @click="
                [emptyDevices(), setRoute('all'),getTotalDevices('all'), getDevices('all')]
              "
              >All</a
            >
          </li>
        </ul>
        <div class="tab-content" id="myTabContent">
          <div
            class="tab-pane fade"
            :class="[currentPage ? currentPage.includes('cust') ? 'show active': '' : '']"
            id="home"
            role="tabpanel"
            aria-labelledby="home-tab"
          >
            <div class="row">
              <Custdrpdwn v-on:sendCustomer="setCustId" />
              <Paginate
                :total="totalRecCount"
                :pgNum="pageNum"
                v-on:sendPageNum="setPageNum"
                v-if="devices.length"
              />
            </div>
            <Devicesnew :devices="devices" v-if="devices.length" />
            <div class="col-sm-12 p-5 text-center" v-if="noData === 2">
              No matching records found.
            </div>
          </div>
          <div
            class="tab-pane fade"
            :class="[currentPage ? currentPage.includes('loc') ? 'show active': '' : '']"
            id="profile"
            role="tabpanel"
            aria-labelledby="profile-tab"
          >
            <div class="row">
              <Placesdepdwn v-on:sendPlace="setPlace" />
              <Paginate
                :total="totalRecCount"
                :pgNum="pageNum"
                v-on:sendPageNum="setPageNum"
                v-if="devices.length"
              />
            </div>
            <Devicesnew :devices="devices" v-if="devices.length" />
            <div class="col-sm-12 p-5 text-center" v-if="noData === 2">
              No matching records found.
            </div>
          </div>
          <div
            class="tab-pane fade"
            :class="[currentPage ? currentPage.includes('all') ? 'show active': '' : '']"
            id="contact"
            role="tabpanel"
            aria-labelledby="contact-tab"
          >
            <Searchbox
              v-on:searchInput="searchDevice"
              v-on:clear="clearSearch"
            />
            <Paginate
              :total="totalRecCount"
              :pgNum="pageNum"
              v-on:sendPageNum="setPageNum"
              v-if="devices.length"
            />
            <Devicesnew
              :devices="devices"
              v-if="devices.length"
              v-on:deviceDeleted="removeDevice"
            />
            <div class="col-sm-12 p-5 text-center" v-if="noData === 2">
              No matching records found.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from "./Sidebar";
import Custdrpdwn from "./Custdrpdwn";
import Placesdepdwn from "./Placesdrpdwn";
import Devicesnew from "./Devicesnew";
import Paginate from "../Paginate";
import Searchbox from "./Searchbox";
import { apiCall } from "@/utils/api";

export default {
  mounted() {
    if(!this.$route.query.type)
    {
      this.setRoute('cust')
    }
    else
    {
    let type = this.$route.query.type;
    let param = this.$route.query.ip;
    if (type === "all") {
      this.getDevices("all");
      this.getTotalDevices("all");
    } else if (param && type === "cust") {
      this.custId = param;
      this.getDevices({ custId: param });
      this.getTotalDevices({ custId: param });
    } else if (param && type === "loc") {
      this.place = param;
      this.getDevices({ place: param });
      this.getTotalDevices({ plc: param });
    }
    }
  },
  data() {
    return {
      devices: [],
      totalRecCount: 0,
      onlineCount : 0,
      offlineCount : 0,
      pageNum: 1,
      custId: "",
      place: "",
      ip: "",
      noData: 1,
      activeNav : "navActive"
    };
  },
  computed: {
    currentPage() {
      if(this.$route.query)
      return this.$route.query.type;
    },
  },
  components: {
    Sidebar,
    Custdrpdwn,
    Placesdepdwn,
    Devicesnew,
    Paginate,
    Searchbox,
  },
  methods: {
    getDevices(param) {
      this.devices = [];
      const baseURI = `device/devices/by-param`;
      let filter = { page: this.pageNum };
      if (this.custId) {
        filter["custId"] = this.custId;
      } else if (this.place) {
        filter["place"] = this.place;
      } else if (this.ip) {
        filter["ip"] = this.ip;
      }
      apiCall({ url: baseURI, method: "get", params: filter }).then(
        (result) => {
          if (!result.devices.length) this.noData = 2;
          else this.noData = 3;
          this.devices = result.devices;
        }
      );
    },
    getTotalDevices(param) {
      let filter = {};
      if (this.custId) {
        filter["custId"] = this.custId;
      } else if (this.place) {
        filter["place"] = this.place;
      } else if (this.ip) {
        filter["ip"] = this.ip;
      }
      const countURI = `device/total/by-param`;
      if (param === "all") {
        apiCall({ url: countURI, methods: "get" }).then((result) => {
          this.totalRecCount = result.total;
          this.onlineCount = result.onlineCount || 0;
          this.offlineCount = result.offlineCount || 0;
        });
      } else {
        apiCall({ url: countURI, methods: "get", params: filter }).then(
          (result) => {
            this.totalRecCount = result.total;
            this.onlineCount = result.onlineCount || 0;
            this.offlineCount = result.offlineCount || 0;
          }
        );
      }
    },
    searchDevice(param) {
      this.pageNum = 1;
      this.place = "";
      this.custId = "";
      this.ip = param;
      this.getDevices(this.ip);
      this.getTotalDevices(this.ip);
    },
    removeDevice(id) {
      this.devices = this.devices.filter((elm) => {
        return elm.devId !== id;
      });
    },
    clearSearch() {
      this.pageNum = 1;
      this.ip = "";
      this.getTotalDevices("all");
      this.getDevices("all");
    },
    setPageNum(pageNum) {
      this.pageNum = pageNum;
      this.getDevices(this.custId);
    },
    setCustId(id) {
      this.pageNum = 1;
      this.place = "";
      this.ip = "";
      this.custId = id;
      this.getDevices(id);
      this.getTotalDevices({ custId: id });
      this.$router.push({ query: { type: "cust", ip: id } });
    },
    setPlace(place) {
      this.pageNum = 1;
      this.custId = "";
      this.ip = "";
      this.place = place;
      this.getDevices(place);
      this.getTotalDevices({ plc: place });
      this.$router.push({ query: { type: "loc", ip: place } });
    },
    setRoute(param){
    this.$router.push({ query: { type: param, ip:"" } });
    },
    emptyDevices() {
      this.noData = 3;
      this.pageNum = 1;
      this.place = "";
      this.custId = "";
      this.devices = [];
    },
  },
};
</script>

<style scoped>
.cnt {
  font-size: 0.8rem;
}
.num {
  font-size: 1rem;
  font-weight: 500;
}
.navActive {
    color: #495057;
    background-color: #fff;
    border-color: #dee2e6 #dee2e6 #fff;
}
</style>